import { render, staticRenderFns } from "./mcp-code-example.vue?vue&type=template&id=5379ef4d&scoped=true&"
import script from "./mcp-code-example.vue?vue&type=script&lang=js&"
export * from "./mcp-code-example.vue?vue&type=script&lang=js&"
import style0 from "./mcp-code-example.vue?vue&type=style&index=0&id=5379ef4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5379ef4d",
  null
  
)

export default component.exports